"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.HomeEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../../types");
var constants_1 = require("../../../constants");
var fields_1 = require("../../../fields");
var slices_1 = require("../../../slices");
var page_factory_1 = require("./page-factory");
var migrationRegion = function (prismicDoc, logger) {
    var _a, _b;
    return constants_1.toLocalization((_a = prismicDoc.data) === null || _a === void 0 ? void 0 : _a.region, logger) ||
        constants_1.toLocalization((_b = prismicDoc.data) === null || _b === void 0 ? void 0 : _b.main_region, logger) ||
        types_1.Localization.National;
};
exports.HomeEntity = page_factory_1.pageFactory(types_1.PageType.HOME, function (prismicDoc, normalizedPage, logger) {
    var _a, _b, _c;
    return utils_1.compact(__assign(__assign({}, normalizedPage), { uid: migrationRegion(prismicDoc, logger), region: constants_1.toLocalization((_a = prismicDoc.data) === null || _a === void 0 ? void 0 : _a.region, logger), displayRegionalMenu: fields_1.toBoolean((_b = prismicDoc.data) === null || _b === void 0 ? void 0 : _b.display_regional), body: slices_1.toSlices((_c = prismicDoc.data) === null || _c === void 0 ? void 0 : _c.body_slices, logger) }));
});
//# sourceMappingURL=home.js.map